import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import { SNETHeader } from "shared/dist/components";
import LoggedInActions from "./LogActions/LoggedInActions.js";
import LoggedOutActions from "./LogActions/LoggedOutActions.js";
import { navbarItems } from "./navbarItemsConstant.js";
import { selectOrganization } from "../../Services/Redux/actionCreators/organizationActions";
import { useNavigateTo } from "../../GlobalRouter/hook/NavigateTo.js";

const Header = () => {
    const { selectedOrganizationUuid, isLoggedIn, orgFoundInBlockchain } = useSelector(
        (state) => ({
            selectedOrganizationUuid: state.organization.selectedOrganizationUuid,
            orgFoundInBlockchain: state.organization.foundInBlockchain,
            isLoggedIn: state.user.isLoggedIn,
        }),
        shallowEqual
    );
    const dispatch = useDispatch();
    const navigateTo = useNavigateTo();

    const handleLogoClick = async () => {
        if (!isLoggedIn) {
            return;
        }
        if (!selectedOrganizationUuid) {
            navigateTo.overview();
            return;
        }
        await dispatch(selectOrganization(selectedOrganizationUuid));
        if (orgFoundInBlockchain) {
            return navigateTo.services({ orgUuid: selectedOrganizationUuid });
        }
        return navigateTo.organizationSetup({ orgUuid: selectedOrganizationUuid });
    };

    const navbarItemsByLogin = !isLoggedIn ? navbarItems : null;

    return (
        <SNETHeader
            isLoggedIn={isLoggedIn}
            onLogoClick={handleLogoClick}
            portalName="AI Publisher"
            color="white"
            LoggedInActions={LoggedInActions}
            LoggedOutActions={LoggedOutActions}
            navbarItems={navbarItemsByLogin}
            isMobileHeaderVisible={false}
        />
    );
};

export default Header;
